export default "__VITE_ASSET__CmOwu9pp__"